var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaginationArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7H12V5C12 3.89543 11.1046 3 10 3H4C2.89543 3 2 3.89543 2 5V11C2 12.1046 2.89543 13 4 13H8V10.75C7.80806 10.75 7.61612 10.6768 7.46967 10.5303L5.46967 8.53033C5.17678 8.23744 5.17678 7.76256 5.46967 7.46967L7.46967 5.46967C7.76256 5.17678 8.23744 5.17678 8.53033 5.46967C8.82322 5.76256 8.82322 6.23744 8.53033 6.53033L7.06066 8L8.00088 8.94022C8.03249 7.8633 8.91543 7 10 7Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17H16C17.1046 17 18 16.1046 18 15V9C18 7.89543 17.1046 7 16 7H10C8.89543 7 8 7.89543 8 9V15C8 16.1046 8.89543 17 10 17ZM12.5303 9.46967C12.2374 9.17678 11.7626 9.17678 11.4697 9.46967C11.1768 9.76256 11.1768 10.2374 11.4697 10.5303L12.9393 12L11.4697 13.4697C11.1768 13.7626 11.1768 14.2374 11.4697 14.5303C11.7626 14.8232 12.2374 14.8232 12.5303 14.5303L14.5303 12.5303C14.8232 12.2374 14.8232 11.7626 14.5303 11.4697L12.5303 9.46967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaginationArrows);
export default __webpack_public_path__ + "static/media/icon-pagination-arrows.ec23382c20e6219c50df179e3e6d10c2.svg";
export { ForwardRef as ReactComponent };